import { render } from "./OfferingSingle.vue?vue&type=template&id=6e4db5f0&scoped=true"
import script from "./OfferingSingle.vue?vue&type=script&lang=js"
export * from "./OfferingSingle.vue?vue&type=script&lang=js"

import "./OfferingSingle.vue?vue&type=style&index=0&id=6e4db5f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e4db5f0"

export default script